<template>
  <VModal ref="modal" @modal:hidden="$emit('close')" :disable-backdrop-click="disableBackdropClick">
    <div class="mx-auto bg-white rounded-lg text-left shadow-xl w-full" :class="customClasses">
      <div class="flex flex-col">
        <div class="flex-none px-4 py-4 sm:px-6 border-b border-gray-200 rounded-t-lg">
          <div class="flex justify-between items-center">
            <div class="flex-1">
              {{ title }}
            </div>
            <div class="flex-none">
              <button
                type="button"
                class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click="close"
              >
                <span class="sr-only">Close</span>
                <svg
                  class="inline-flex h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div
          class="flex-1 px-4 pt-4 pb-4 sm:pb-6 sm:px-6 rounded-b-lg"
          :class="[gray && 'bg-gray-100']"
        >
          <slot :close="close" />
        </div>
      </div>
    </div>
  </VModal>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Modal Title',
    },
    disableBackdropClick: Boolean,
    customClasses: {
      type: Array,
      default: () => [],
    },
    gray: Boolean,
  },
  methods: {
    close() {
      this.$refs.modal.close();
    },
  },
};
</script>
